import { render, staticRenderFns } from "./quotationList.vue?vue&type=template&id=a401d20a&scoped=true"
import script from "./quotationList.vue?vue&type=script&lang=js"
export * from "./quotationList.vue?vue&type=script&lang=js"
import style0 from "./quotationList.vue?vue&type=style&index=0&id=a401d20a&prod&lang=scss&scoped=true"
import style1 from "./quotationList.vue?vue&type=style&index=1&id=a401d20a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a401d20a",
  null
  
)

export default component.exports